const vm = {
    "vm.title.block1": "Cermin",
    "vm.title.block2": "Virtual",
    "vm.defineClassic": "Define® Classic",
    "vm.defineFresh": "Define® Fresh",
    "vm.learnmore": "Pelajari Lebih Lanjut",
    "vm.shownow": "Belanja Sekarang",
}

export default vm;